import React from 'react';
import api from '../../../../../../services/api';
import { useToast } from '../../../../../../hooks/Toast';

import { useAuth } from '../../../../../../hooks/Auth';
import { FiSend } from 'react-icons/fi';
import Whatsapp from '../../../../../../components/Whatsapp';
import { authTitle } from '../../../../../../config';
import { FaMailBulk, FaPaperPlane, FaWhatsapp } from 'react-icons/fa';
import { useLoading } from 'src/hooks/LoadingHook';
import { useModal } from 'src/hooks/Modal';
import sleep from 'src/utils/sleep';
import { useSearch } from 'src/hooks/Search';

interface ICreateModule {
  lineData: Record<string, any>;
}

export default function ContactModule({

  lineData,

}: ICreateModule): JSX.Element {

  const { addLoading, removeLoading } = useLoading();
  const { addModal } = useModal();
  const { addToast } = useToast();

  const { reloadSearchAll } = useSearch();

  function formatName(name) {
    if (!name) return '';

    // Divide o nome completo em palavras
    const nameParts = name.trim().split(' ');

    // Pega o primeiro e último nome
    const firstName = nameParts[0];
    const lastName = nameParts.length > 1 ? nameParts[nameParts.length - 1] : '';

    // Função para capitalizar a primeira letra e deixar o restante minúsculo
    const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();

    // Retorna o primeiro e último nome formatados
    return `${capitalize(firstName)} ${capitalize(lastName)}`;
  }
  const sendMailCheck = async (code) => {
    const invite = await api.get(`/invitation/${lineData?.invitation_id}`);

    // Quebrando a descrição em linhas
    let description = invite?.data?.description ?? '';


    // Substituindo o placeholder NOME pelo nome formatado
    const text = description.replace('{NOME}', formatName(lineData?.name));

    // Usar encodeURIComponent e garantir que quebras de linha sejam %0A
    const formattedText = encodeURIComponent(text).replace(/%0A/g, '%0A');

    // Abrindo a URL no WhatsApp com o texto codificado
    window?.open(
      `https://api.whatsapp.com/send?l=pt&phone=${code}${lineData?.phone}&text=${formattedText}`,
      '_BLANK'
    );

    await api.put(`/invitation-confirmation/${lineData?._id?.toString()}/confirmated`, { confirmated: 'Sim' });
    reloadSearchAll();


  };



  const moduleUpdate = (data: Record<string, any>): JSX.Element => (<>
    <button className='lineIcon' title='Enviar Whatsapp sem adicionar código' onClick={() => { sendMailCheck('') }}><FaWhatsapp /></button>

    <button className='lineIcon' title='Enviar Whatsapp com Código BR' onClick={() => { sendMailCheck('55') }}><FaWhatsapp color='green' /></button>

  </>
  );

  return moduleUpdate(lineData);
}
